import {
  API_GET_REPORT_UPLOAD_STATUS,
  API_GET_SIGNED_DOCUMENT,
  API_POST_DOCUMENT,
  API_POST_SALES_DOCUMENT,
} from 'common/constants/apis';
import { IDocumentUploadResp } from 'common/interfaces/idocument';
import UILogger from 'common/utils/logger';
import { retrieveUserAuthToken } from './db-service';
import { AxiosRequestConfig } from 'axios';
import { DEFAULT_RETRY_CONFIG } from 'common/constants';
import httpClient from './config';
import { IReportExportDataResponse } from 'common/interfaces/iDayReports';
import { config } from 'config';

export async function postDocument<T>(
  file: any,
  type: 'document' | 'salesAttachment',
  onUploadProgress: (sent: number, total: number) => void,
): Promise<IDocumentUploadResp<T>> {
  console.log('posting document...', file);

  let postUrl = config.api.rest;
  switch (type) {
    case 'document':
      postUrl += API_POST_DOCUMENT;
      break;
    case 'salesAttachment':
      postUrl += API_POST_SALES_DOCUMENT;
      break;
  }

  console.log('posting document...', postUrl);
  const tkn = await retrieveUserAuthToken();

  // Create FormData to mimic multipart/form-data
  const formData = new FormData();
  formData.append('file', file);

  // Configure headers
  const headers = {
    Accept: 'application/json',
    Authorization: 'Bearer ' + tkn,
  };

  return new Promise<IDocumentUploadResp<T>>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', postUrl, true);

    // Track upload progress
    xhr.upload.addEventListener('progress', (event) => {
      if (event.lengthComputable) {
        const percent = (event.loaded / event.total) * 100;
        onUploadProgress(event.loaded, event.total); // Call the progress function
      }
    });

    // Handle the response
    xhr.onload = () => {
      if (xhr.status === 200) {
        try {
          const _resp = JSON.parse(xhr.responseText);
          if (_resp?.status?.success) {
            resolve(_resp);
          } else {
            resolve({ status: { success: false } } as IDocumentUploadResp<T>);
          }
        } catch (error) {
          console.error('Error parsing response:', error);
          reject(error);
        }
      } else {
        console.error('postDocument response:', xhr.responseText);
        reject(xhr.responseText);
      }
    };

    // Handle errors
    xhr.onerror = () => {
      console.error('Error uploading document');
      reject(new Error('Error uploading document'));
    };

    // Send the request with the form data
    xhr.setRequestHeader('Content-Type', 'multipart/form-data');
    xhr.setRequestHeader('Authorization', 'Bearer ' + tkn);
    xhr.send(formData);
  }).catch((error) => {
    console.error('Error in uploading document', error);
    return { status: { success: false } } as IDocumentUploadResp<T>;
  });
}

export const getPreSignedDocument = (url: string): Promise<string> => {
  UILogger.info('Sending signed url request', url);
  return httpClient
    .post(
      API_GET_SIGNED_DOCUMENT,
      {
        documentUrl: url,
      },
      DEFAULT_RETRY_CONFIG as AxiosRequestConfig,
    )
    .then((res) => {
      UILogger.log('signed url response: ', res.data);
      return res.data?.data;
    })
    .catch((error) => {
      console.log('Error upserting shiftConfig:::', error.response.data);
      return error.response.data;
    });
};

export const fetchReportUploadStatus = (id: number): Promise<IReportExportDataResponse> => {
  UILogger.info('fetchReportUploadStatus', id);
  return httpClient
    .get(API_GET_REPORT_UPLOAD_STATUS.replace('{id}', id.toString()))
    .then((res) => {
      UILogger.log('fetchReportUploadStatus: ', res.data);
      return res.data?.data;
    })
    .catch((error) => {
      console.log('fetchReportUploadStatus::', error.response.data);
      return error.response.data;
    });
};
